/**
 * API client per la gestione dei draft di risposta automatica.
 * 
 * Endpoint:
 * - GET /api/v1/drafts/ - Lista draft in attesa
 * - POST /api/v1/drafts/:emailId/approve - Approva e invia draft
 * - POST /api/v1/drafts/:emailId/edit - Modifica draft
 * - POST /api/v1/drafts/:emailId/reject - Rifiuta draft
 */

import axios from 'axios';

export interface DraftItem {
  email_id: string;
  thread_id: string;
  subject: string | null;
  body: string;
  category: string | null;
  priority: string | null;
  from_email: string;
  draft_body: string;
  received_at: string;
}

export interface EditDraftRequest {
  body: string;
}

const api = axios.create({
  baseURL: '/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const draftsApi = {
  /**
   * Lista tutti i draft in attesa di review.
   */
  list: async (): Promise<DraftItem[]> => {
    const response = await api.get<DraftItem[]>('/drafts/');
    return response.data;
  },

  /**
   * Approva un draft e invia l'email.
   * @param emailId - ID dell'email da approvare
   */
  approve: async (emailId: string): Promise<{ message: string }> => {
    const response = await api.post<{ message: string }>(`/drafts/${emailId}/approve`);
    return response.data;
  },

  /**
   * Modifica il corpo di un draft.
   * @param emailId - ID dell'email da modificare
   * @param body - Nuovo corpo del draft
   */
  edit: async (emailId: string, body: string): Promise<{ message: string; draft: string }> => {
    const response = await api.post<{ message: string; draft: string }>(`/drafts/${emailId}/edit`, {
      body,
    } as EditDraftRequest);
    return response.data;
  },

  /**
   * Rifiuta un draft (lo rimuove e reimposta lo status a PENDING_VET).
   * @param emailId - ID dell'email da rifiutare
   */
  reject: async (emailId: string): Promise<{ message: string }> => {
    const response = await api.post<{ message: string }>(`/drafts/${emailId}/reject`);
    return response.data;
  },
};
